import { render, staticRenderFns } from "./OtaApp.vue?vue&type=template&id=8c1aef6a&scoped=true&"
import script from "./OtaApp.vue?vue&type=script&lang=js&"
export * from "./OtaApp.vue?vue&type=script&lang=js&"
import style0 from "./OtaApp.vue?vue&type=style&index=0&id=8c1aef6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1aef6a",
  null
  
)

export default component.exports